var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs22"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style26"
  }, ".cls-1{fill:#010101;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Left_Circle"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0C7.164,0,0,7.164,0,16c0,8.837,7.164,16,16,16c8.837,0,16-7.163,16-16C32,7.164,24.837,0,16,0z M16,30   C8.268,30,2,23.732,2,16C2,8.268,8.268,2,16,2s14,6.268,14,14C30,23.732,23.732,30,16,30z",
    className: "fil0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(-19.952108,-17.517809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g61",
    transform: "translate(-20.289282,-11.975638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 48.936127,41.400822 v 12.508767 a 0.521199,0.521199 0 0 0 1.042398,0 V 41.400822 a 5.4725857,5.4725857 0 0 1 10.945171,0 v 11.250072 l -4.841935,-4.847147 a 0.52241077,0.52241077 0 0 0 -0.740102,0.737496 l 5.733185,5.733185 0.02606,0.02085 a 0.31271919,0.31271919 0 0 0 0.05472,0.0443 l 0.02606,0.01564 0.06254,0.03388 h 0.03128 c 0.02346,0 0.0443,0.01564 0.06515,0.02085 a 0.52119864,0.52119864 0 0 0 0.208479,0 c 0.02085,0 0.0417,-0.01303 0.06515,-0.02085 h 0.03128 l 0.06254,-0.03388 0.02606,-0.01564 a 0.47950275,0.47950275 0 0 0 0.05733,-0.0443 0.1902375,0.1902375 0 0 1 0.02346,-0.02085 l 5.733183,-5.733185 a 0.52119864,0.52119864 0 0 0 0,-0.737496 0.52119864,0.52119864 0 0 0 -0.737494,0 l -4.844541,4.847147 V 41.400822 a 6.5149832,6.5149832 0 0 0 -13.029966,0 z",
    id: "path50",
    className: "fil0",
    style: {
      strokeWidth: 0.999996
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g11"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g13"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g15"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g17"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.e2c714b015a67a53f6e963f67f1be3a2.svg";
export { ForwardRef as ReactComponent };